export const giftCardRule = /[A-Za-z0-9\-]{19}/gm;
export const cnpj_regex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/;
// regex para cartão de crédito
export const elo_regex =
  /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/;
export const hipercard_regex =
  /^(?:3841[046]0|6(?:06282|37(?:095|5(?:68|99)|6(?:09|12))))/;
export const visa_regex = /^4\d{5}/;
export const mastercard_regex =
  /^(5[1-5]\d{4}|2(2(2[1-9]\d{2}|[3-9]\d{3})|[3-6]\d{4}|7([01]\d{3}|20\d{2})))/;
export const cpf_regex = /^[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}$/;
export const cpf_regex2 = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
